angular.module('unica_invitation.invitation_controllers')

.controller('InvitationListController',
	function(
		CONFIG,
		$rootScope, $scope, $stateParams,
		UserListService, InvitationCreateService, InvitationListService,
		InvitationListListService,
		InvitationDeleteService, InvitationEditService, CheckService, Session,
		$confirm, $uibModal
	) {

	$scope.invitation_list_id = $stateParams.invitation_list_id;
	$scope.event_id           = $stateParams.event_id;

	$rootScope.getInvitationsLists( $stateParams.event_id );

	$rootScope.getEventFields( $stateParams.event_id );

	$rootScope.getEvent( $stateParams.event_id );

	$scope.notificationType = null;
	$scope.$on('event_loaded', function() {
		$scope.notificationType = $rootScope.eventData.notification_type;
	});

	$scope.mediaFields = [];
	$scope.$on('event_field_loaded', function() {
		angular.forEach($rootScope.eventFieldData, function(eventField, key) {
			if ( eventField.type === 'image' || eventField.type === 'file' ) {
				$scope.mediaFields.push( eventField );
			}
		});
	});

	$rootScope.getInvitationList( $stateParams.invitation_list_id );

	$scope.invitations = [];
	$scope.usersToExclude = [];
	$scope.limit  = 5;
	$scope.offset = 0;

	$scope.userSearch = '';

	$scope.notifyInvitationTags = function() {
		if ( !$scope.notificationType ) {
			$scope.showErrorMsg(
				'Per poter inviare le notifiche è necessario impostare il tipo di notifica nella pagina di modifica evento'
			);
		} else {
			$confirm({
				title: 'Sei sicuro di voler procedere con l\'invio delle notifiche?',
				text: 'Confermi l\'invio delle notifiche (' + $scope.notificationType + ') a tutti i confermati della lista?'
			}).then(function() {

				$scope.showLoader();
				InvitationEditService
					.sendNotifications( { event_id: $scope.event_id, invitation_list_id: $scope.invitation_list_id }  )
					.then(function(data) {
						$scope.hideLoader();

						if ( data ) {
							// I non raggiungibili sono quelli che non hanno numero impostato o non hanno l'app
							$scope.showSuccessMsg(
								'Invio di ' + data.notifiche +  ' notifiche ' + data.type + ' avviato con successo!' +
								' (' + data.not_defined + ' non raggiungibili)', ''
							);
						}

					});

			}, function() {
				// Cancel
			});
		}

	};


	$scope.searchInvitation = function(search) {
		$scope.showLoader();
		$scope.offset = 0;

		InvitationListService
			.searchInList($scope.invitation_list_id, search, $scope.limit, $scope.offset)
			.then(function(data) {
				$scope.hideLoader();

				if ( data.length > 0 ) {
					$scope.invitations = data;

					$scope.canLoad = true;
					$scope.offset = $scope.offset + data.length;

					return data;
				} else {
					$scope.invitations = [];
					$scope.canLoad = false;

					return null;
				}
			});
	};


	$scope.loadInvitations = function() {
		$scope.showLoader();
		$scope.canLoad = false;

		if ( $scope.userSearch !== '' ) {

			InvitationListService
				.searchInList($scope.invitation_list_id, $scope.userSearch, $scope.limit, $scope.offset)
				.then(function(data) {
					$scope.hideLoader();

					if ( data.length > 0 ) {
						$scope.invitations = $scope.invitations.concat( data );

						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					} else {
						$scope.canLoad = false;
					}
				});


		} else {

			InvitationListService
				.list( $rootScope.invitationListData.id, $scope.limit, $scope.offset )
				.then(function(data) {
					$scope.hideLoader();

					angular.forEach(data, function(invitation, key) {
						if ( invitation.user ) {
							$scope.usersToExclude.push(invitation.user.id);
						}
					});

					$scope.invitations = $scope.invitations.concat( data );

					if ( data.length === 0 ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				});

		}
	};


	$scope.$on( 'invitation_list_loaded', function() {
		$scope.loadInvitations();
	});


	$scope.userList = [];
	$scope.asyncSelected = undefined;
	$scope.ibNoResults = false;
	$scope.loadingUsers = false;
	$scope.searchUser = function(search) {
		$scope.loadingUsers = true;
		UserListService
			.search(search, $scope.usersToExclude, $scope.invitation_list_id)
			.then(function(data) {
				$scope.loadingUsers = false;
				if ( data.length > 0 ) {
					$scope.ibNoResults = false;
					$scope.userList = data;
					return data;
				} else {
					$scope.userList = [];
					$scope.ibNoResults = true;
					return null;
				}
			});
	};

	$scope.$watch('asyncSelected', function() {
		if ( $scope.asyncSelected !== undefined && $scope.asyncSelected.length == 0 ) {
			$scope.userList = [];
		}
	});

	$scope.inviteUser = function(userId) {
		$scope.inviteSelectedUser( [ userId ] );
	};


	$scope.inviteSelectedUser = function(userIds)
	{
		if (!userIds) {
			userIds = [];
			angular.forEach($scope.userList, function(user, key) {
				if ( user.checked ) {
					userIds.push(user.id);
				}
			});
		}

		$scope.showLoader();
		InvitationCreateService.inviteUser({
			event: $rootScope.eventData.id,
			invitation_list: $rootScope.invitationListData.id,
			users: userIds
		})
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					$scope.asyncSelected = '';

					angular.forEach(data, function(invitation) {
						$scope.usersToExclude.push(invitation.user_id);
						$scope.invitations.push(invitation);
					});

					$scope.showSuccessMsg('Partecipante aggiunto alla lista con successo!', '');
				} else {
					$rootScope.manageError(data);
				}
			});
	};


	$scope.moveInvitation = function(invitationId)
	{
		var modalInstance = $uibModal.open({
			animation: true,
			ariaLabelledBy: 'modal-title',
			ariaDescribedBy: 'modal-body',
			templateUrl: './templates/modals/invitation-move.html',
			controller: 'ModalMoveInvitationInstanceController',
			controllerAs: '$ctrl',
			size: 'lg',
			windowClass: 'modal-user-detail',
			resolve: {
				invitationId: function () {
					return invitationId;
				},
				invitationListId: function () {
					return $scope.invitation_list_id;
				},
			}
		});

		modalInstance.result.then(function (data) {
			if( data ) {
				// $scope.invitations = [];
				// $scope.loadInvitations();

				angular.forEach($scope.invitations, function(invitation, key) {
					if ( invitation.id == invitationId ) {
						angular.forEach($scope.usersToExclude, function(userToExclude, index) {
							if ( userToExclude == invitation.user.id ) {
								$scope.usersToExclude.splice(index, 1);
							}
						});
						$scope.invitations.splice(key, 1);
						$scope.offset--;
					}
				});
				// $scope.showSuccessMsg('Invito spostato con successo!', '');

			}
		}, function () { });
	};


	$scope.deleteInvitation = function(invitationId)
	{
		$confirm({
			title: 'Sei sicuro di voler eliminare l\'invito?',
			text: 'Confermi la cancellazione dell\'invito?'
		}).then(function() {

			$scope.showLoader();
			InvitationDeleteService.delete({ id: invitationId })
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.invitations, function(invitation, key) {
							if ( invitation.id == invitationId ) {
								angular.forEach($scope.usersToExclude, function(userToExclude, index) {
									if ( userToExclude == invitation.user.id ) {
										$scope.usersToExclude.splice(index, 1);
									}
								});
								$scope.invitations.splice(key, 1);
								$scope.offset--;
							}
						});
						$scope.showSuccessMsg('Invito eliminato con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});
	};

	function checkInInvitation(invitationId, hash)
	{
		$scope.showLoader();
		CheckService
			.checkInInvitation( hash )
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					angular.forEach($scope.invitations, function(invitation, key) {
						if ( invitation.id == invitationId ) {
							$scope.invitations[key].checked_in = !$scope.invitations[key].checked_in;
						}
					});
					$scope.showSuccessMsg('Check-in effettuato con successo!', '');
				} else {
					$rootScope.manageError(data);
				}
			});
	}

	function checkOutInvitation(invitationId, hash)
	{
		$scope.showLoader();
		CheckService
			.checkOutInvitation( hash )
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					angular.forEach($scope.invitations, function(invitation, key) {
						if ( invitation.id == invitationId ) {
							$scope.invitations[key].checked_in = !$scope.invitations[key].checked_in;
						}
					});
					$scope.showSuccessMsg('Check-out effettuato con successo!', '');
				} else {
					$rootScope.manageError(data);
				}
			});
	}

	$scope.checkInvitation = function(invitationId, hash, checkIn) {
		if ( checkIn ) {
			checkInInvitation( invitationId, hash );
		} else {
			checkOutInvitation( invitationId, hash );
		}
	};

	var allUserChecked = false;
	$scope.toggleAllUsers = function() {
		allUserChecked = !allUserChecked;
		angular.forEach($scope.userList, function(user, key) {
			if ( allUserChecked  ) {
				user.checked = true;
			} else {
				user.checked = false;
			}
			$scope.userList[key] = user;
		});
		$scope.checkAllDisabled();
	};

	$scope.toggleUser = function(userId) {
		angular.forEach($scope.userList, function(user, key) {
			if ( user.id == userId ) {
				user.checked = !user.checked;
				$scope.userList[key] = user;
			}
		});
		$scope.checkAllDisabled();
	};


	$scope.inviteAllDisabled = true;
	$scope.checkAllDisabled = function() {
		$scope.inviteAllDisabled = true;
		angular.forEach($scope.userList, function(user, key) {
			if ( user.checked ) {
				$scope.inviteAllDisabled = false;
			}
		});
	};


	$scope.missingUsers = [];
	$scope.existing_invitations = [];


	$scope.openImportInvitationTagsModal = function ()
	{
		var modalInstance = $uibModal.open({
			ariaLabelledBy: 'modal-title',
			ariaDescribedBy: 'modal-body',
			controller: 'ModalImportInvitationTagsInstanceController',
			controllerAs: '$ctrl',
			templateUrl: './templates/modals/import-invitation-tags.html',
			size: 'lg',
			windowClass: 'modal-invitation-list'
		});

		modalInstance.result.then(function (data) {

			console.log( data );

			if ( data.result === 'ko' ) {
				$scope.showErrorMsg( data.message );
				return;
			}

			if ( data.skipped.length > 0 ) {
				$scope.showWarningMsg('Tag aggiornati con successo! Le seguenti righe sono state saltate: ' + data.skipped.join(', '), '');
			} else {
				$scope.showSuccessMsg('Tag aggiornati con successo!', '');
			}

		}, function () { });
	};

	$scope.openImportInvitationsModal = function ()
	{
		var modalInstance = $uibModal.open({
			ariaLabelledBy: 'modal-title',
			ariaDescribedBy: 'modal-body',
			controller: 'ModalImportInvitationsInstanceController',
			controllerAs: '$ctrl',
			templateUrl: './templates/modals/import-invitations.html',
			size: 'lg',
			windowClass: 'modal-invitation-list'
		});

		modalInstance.result.then(function (data) {

			if ( data.result === 'ko' ) {
				$scope.showErrorMsg( data.message );
				return;
			}

			if ( data.missing_users.length > 0 ) {
				$scope.missingUsers = data.missing_users;
			}

			if ( data.existing_invitations.length > 0 ) {
				$scope.existingInvitations = data.existing_invitations;
			}

			if ( data.invitations.length > 0 ) {
				$scope.loadInvitations();
			}

		}, function () { });
	};


	$scope.resendInvitation = function(invitationId)
	{
		$confirm({
			title: 'Sei sicuro di voler reinviare l\'invito?',
			text: 'Confermi il reinvio dell\'invito?'
		}).then(function() {

			$scope.showLoader();
			InvitationEditService
				.resendInvitation( invitationId )
				.then(function() {
					$scope.hideLoader();

					$scope.showSuccessMsg('Invito reinviato con successo!', '');
				});

		});
	};


	$scope.resendConfirmation = function(invitationId)
	{
		$confirm({
			title: 'Sei sicuro di voler reinviare la conferma di invito?',
			text: 'Confermi il reinvio della conferma di invito?'
		}).then(function() {

			$scope.showLoader();
			InvitationEditService
				.resendConfirmation( invitationId )
				.then(function(data) {
					$scope.hideLoader();

					$scope.showSuccessMsg('Conferma reinviata con successo!', '');
				});

		});
	};


	$scope.downloadExportAvatarZip = false;
	$scope.exportAvatarZipUrl      = '';

	$scope.prepareAvatarZip = function()
	{
		$scope.showLoader();
		InvitationListListService
			.exportAvatarZip( $stateParams.event_id, $stateParams.invitation_list_id )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					console.log(url);
					$scope.downloadExportAvatarZip = true;
					$scope.exportAvatarZipUrl      = url;
				}
			});

	}



	$scope.prepareCustomFieldZip = function( eventFieldId, index )
	{
		$scope.showLoader();
		InvitationListListService
			.exportCustomFieldZip( eventFieldId, $stateParams.invitation_list_id )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.mediaFields[index].downloadExportZip = true;
					$scope.mediaFields[index].exportZipUrl      = url;
				}
			});

	}


	$scope.downloadExportInvitation = false;
	$scope.exportInvitationUrl      = '';

	$scope.prepareInvitationExportSelectedUrl = function()
	{
		$scope.showLoader();
		InvitationListListService
			.exportInvitationList( $stateParams.invitation_list_id )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.downloadExportInvitation = true;
					$scope.exportInvitationUrl      = url;
				}
			});
	};


	function _openInvitationStatusModal()
	{
		var modalInstance = $uibModal.open({
			animation: true,
			ariaLabelledBy: 'modal-title',
			ariaDescribedBy: 'modal-body',
			templateUrl: './templates/modals/invitation-status.html',
			controller: 'ModalInvitationStatusInstanceController',
			controllerAs: '$ctrl',
			size: 'md',
			windowClass: 'modal-invitation-status',
			resolve: {
				invitation: function () {
					return $rootScope.invitationData;
				},
			}
		});

		modalInstance.result.then(function (data) {
			angular.forEach($scope.invitations, function(invitation, key) {
				if ( invitation.id === data.id ) {
					invitation.status = data.status;
					$scope.invitations[key] = invitation;
				}
			});
		}, function () { });
	}

	function _openInvitationNoteModal()
	{
		var modalInstance = $uibModal.open({
			animation: true,
			ariaLabelledBy: 'modal-title',
			ariaDescribedBy: 'modal-body',
			templateUrl: './templates/modals/invitation-note.html',
			controller: 'ModalInvitationNoteInstanceController',
			controllerAs: '$ctrl',
			size: 'md',
			windowClass: 'modal-invitation-note',
			resolve: {
				invitation: function () {
					return $rootScope.invitationData;
				},
			}
		});

		modalInstance.result.then(function (data) {
			angular.forEach($scope.invitations, function(invitation, key) {
				if ( invitation.id === data.id ) {
					invitation.note = data.note;
					$scope.invitations[key] = invitation;
				}
			});
		}, function () { });
	}

	$rootScope.openInvitationStatusModal = function (invitationId)
	{
		$scope.invitationModel = 'status';
		$rootScope.getInvitationById( invitationId );
	};

	$scope.openInvitationNoteModal = function (invitationId)
	{
		$scope.invitationModel = 'note';
		$rootScope.getInvitationById( invitationId );
	};

	$scope.$on( 'invitation_loaded', function(event, opt) {
		if ( $scope.invitationModel == 'status' ) {
			_openInvitationStatusModal();
		} else if ( $scope.invitationModel == 'note' ) {
			_openInvitationNoteModal();
		}

		$scope.invitationModel = undefined;
	});

})

.controller('ModalImportInvitationsInstanceController',
	function (
		$scope, $stateParams,
		$uibModalInstance, FileUploader, getBaseApiURL, Session
	) {

	$scope.importInvitationsData = {
		csv: ''
	};

	$scope.uploader = new FileUploader({
		removeAfterUpload: true,
		alias: 'csv',
		url: getBaseApiURL + '/import/invitations/' + $stateParams.invitation_list_id,
		headers: {
			Authorization : 'Bearer ' + Session.token,
			Accept: 'application/json'
		}
	});

	$scope.uploader.onCompleteItem = function(fileItem, response) {
		$scope.hideLoader();
		$uibModalInstance.close( response );
	};

	$scope.deleteImportInvitationsCsv = function() {
		angular.element(document.querySelector('.invitations_csv')).val(null);
	};

	$scope.importInvitations = function () {
		$scope.showLoader();
		$scope.uploader.uploadAll();
	};

	$scope.closeModal = function() {
		$uibModalInstance.dismiss('cancel');
	};

})

.controller('ModalImportInvitationTagsInstanceController',
	function (
		$scope, $stateParams,
		$uibModalInstance, FileUploader, getBaseApiURL, Session
	) {

	$scope.importInvitationTagsData = {
		csv: ''
	};

	$scope.formInvalid = true;
	$scope.modalEventId = $stateParams.event_id;


	$scope.uploader = new FileUploader({
		removeAfterUpload: true,
		alias: 'csv',
		url: getBaseApiURL + '/import/invitation-tags/' + $stateParams.invitation_list_id,
		headers: {
			Authorization : 'Bearer ' + Session.token,
			Accept: 'application/json'
		}
	});


	$scope.uploader.onAfterAddingFile = function( fileItem ) {
		$scope.formInvalid = false;
	};

	$scope.changeImportInvitationTags = function() {
		// console.log('test');
	};


	$scope.uploader.onCompleteItem = function(fileItem, response) {
		$scope.hideLoader();
		$uibModalInstance.close( response );
	};

	$scope.deleteImportInvitationTagsCsv = function() {
		angular.element(document.querySelector('.invitation_tags_csv')).val(null);
	};

	$scope.importInvitationTags = function () {
		$scope.showLoader();
		$scope.uploader.uploadAll();
	};

	$scope.closeModal = function() {
		$uibModalInstance.dismiss('cancel');
	};

})


.controller('ModalMoveInvitationInstanceController',
	function ( $rootScope, $scope, $stateParams, $uibModalInstance, invitationId, invitationListId, InvitationEditService) {

		$scope.invitationId = invitationId;
		// $scope.invitationListId = invitationListId;
		$scope.dataIL = {
			invitation_list_to: ''
		};
		$scope.filteredInvitationsLists = [];
		$scope.countIL = 0;
		$rootScope.invitationsLists.forEach(function(invitationList) {
			if (invitationList.id != invitationListId) {
				$scope.filteredInvitationsLists.push(invitationList);
			}
			$scope.countIL++;
		});


		$scope.moveInvitation = function()
		{
			InvitationEditService
				.moveInvitation( $scope.invitationId, $scope.dataIL.invitation_list_to )
				.then(function(data) {
					$scope.hideLoader();

					$uibModalInstance.close( data );

					$scope.showSuccessMsg('Invito aggiornato con successo!', '');
				});
		};

		$scope.closeModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

	})

.controller('ModalInvitationStatusInstanceController',
	function ( $scope, $stateParams, $uibModalInstance, invitation, InvitationEditService) {

	$scope.invitation = invitation;

	$scope.saveInvitation = function()
	{
		InvitationEditService
			.updateStatus( $scope.invitation.id, $scope.invitation.status )
			.then(function(data) {
				$scope.hideLoader();

				$uibModalInstance.close( data );

				$scope.showSuccessMsg('Stato Invito aggiornato con successo!', '');
			});
	};

	$scope.closeModal = function() {
		$uibModalInstance.dismiss('cancel');
	};

})
.controller('ModalInvitationNoteInstanceController',
	function ( $scope, $stateParams, $uibModalInstance, invitation, InvitationEditService) {

	$scope.invitation = invitation;

	$scope.saveInvitation = function()
	{
		InvitationEditService
			.updateNote( $scope.invitation.id, $scope.invitation.service_note )
			.then(function(data) {
				$scope.hideLoader();

				$uibModalInstance.close( data );

				$scope.showSuccessMsg('Note Invito aggiornato con successo!', '');
			});
	};

	$scope.closeModal = function() {
		$uibModalInstance.dismiss('cancel');
	};

});